import styled from 'styled-components';

const Wrapper = styled.div`
   width: 100%;
`;

Wrapper.displayName = 'Wrapper';

export default Wrapper;
